import "./ReinstallButton.css"

export function ReinstallButton(props) {
    return(
        <div className={"btn-holder-reinstall"}>
            <div className={"btn-txt-place-holder"}>
                Reinstall Now
            </div>
        </div>
    )
}